export const Events = Object.freeze({
    aiTestimonialSearch: "vector-search-event",
    testimonialSearch: "paginated-search-event",
    testimonialRemove: "remove-testimonial-event",
    errorToast: "show-error-toast",
    editTestimonial: "open-edit-testimonial",
    testimonialUpdated: "update-testimonial-event",
});
